import api from "../store/services/api";

class IfoodCatalogImportService {
  // Original method - kept for backward compatibility
  getIfoodImportedProducts(params) {
    return api.get(`/ifood-import-catalog-items/`, {
      params: params,
    });
  }

  // New structured API methods
  getMerchantCatalogs(params) {
    return api.get(`/merchant-catalogs/`, {
      params: params,
    });
  }

  getCatalogCategories(merchantId, params) {
    return api.get(`/merchant-catalogs/${merchantId}/categories/`, {
      params: params,
    });
  }

  getCategoryProducts(categoryId, params) {
    return api.get(`/categories/${categoryId}/products/`, {
      params: params,
    });
  }

  getProductComplements(productId, params) {
    return api.get(`/products/${productId}/complements/`, {
      params: params,
    });
  }

  // Hierarchical view method - loads complete structure in one request
  getMerchantCatalogHierarchy(merchantId) {
    return api.get(`/merchants/${merchantId}/catalog-hierarchy/`);
  }

  updateProductAvailability(
    itemId,
    merchantId,
    catalogContext,
    isAvailable,
    itemType = 1
  ) {
    return api.post(`/ifood/product/action/`, {
      platform: "IFOOD",
      action: isAvailable ? "ENABLE" : "DISABLE",
      item_id: itemId,
      merchant_id: merchantId,
      catalog_context: catalogContext,
      item_type: itemType,
    });
  }
}

export default new IfoodCatalogImportService();
